export const USER_LOG_IN = 'user_log_in';
export const CURRENT_USER_INFO = 'current_user_info';
// export const SET_FOLLOWING_ACCOUNTS = 'set_following_accounts';
